/* DON'T EDIT THIS FILE: edit original and run build again */ import { Spinner } from "react-bootstrap";

export const Loading = ({
  variant = "secondary",
  className = "",
  center = false,
}: {
  variant?: string;
  className?: string;
  center?: boolean;
}) => {
  const extraClassName =
    (center ? "w-100 h-100 align-items-center justify-content-center " : "") +
    className;
  return (
    <div className={"d-flex justify-content-center " + extraClassName}>
      <Spinner
        className="m-4"
        animation="border"
        variant={variant}
        size={"lg" as any} // custom lg css
      />
    </div>
  );
};

export const SmallLoading = () => (
  <Spinner animation="border" variant="secondary" size="sm" />
);

export const BigLoading = () => (
  <Spinner
    animation="border"
    variant="tenant"
    className="m-6"
    size={"xl" as any} // custom xl css
  />
);

export const LoadingPage = () => (
  <div className="vw-100 vh-100 bg-primary d-flex flex-column justify-content-center">
    <Loading variant="tenant" />
  </div>
);
